import { useAppStore } from '@/common/states/store/slices';
import { useShallow } from 'zustand/react/shallow';

export const useLeadFilters = () => {
  return useAppStore(
    useShallow((state) => ({
      filters: state.dashboard.leads.filters,
      isFiltering: state.dashboard.leads.isFiltering,
      setFilters: state.dashboard.leads.setFilters,
      resetFilters: state.dashboard.leads.resetFilters,
      applyFilters: state.dashboard.leads.applyFilters,
      setLoadingFilters: state.dashboard.leads.setLoadingFilters,
    })),
  );
};
